import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  return (
    <div className="how-it-works-container">
      <h1>How It Works</h1>
      <p>Welcome to Clean Code Engineer! Here’s how you can get started and make the most of our platform:</p>
      <ol>
        <li><strong>Sign Up:</strong> Create your free account to access all features.</li>
        <li><strong>Freelance Work:</strong> Get help with your freelance projects, job interviews, and real-world tech challenges.</li>
        <li><strong>Browse Courses:</strong> Explore our wide range of training programs and resources.</li>
        <li><strong>Book Sessions:</strong> Schedule counseling or coaching sessions with our experts.</li>
        <li><strong>Track Progress:</strong> Monitor your learning journey and achievements.</li>
        <li><strong>Get Support:</strong> Reach out to our team for any help or guidance.</li>
      </ol>
      <h2>Why Choose Us?</h2>
      <ul>
        <li>Expert trainers and coaches</li>
        <li>Flexible learning options</li>
        <li>Personalized support</li>
      </ul>
      <h2>Frequently Asked Questions</h2>
      <p>Find answers to common questions on our <a href="/faq" className="faq-link">FAQ page</a>.</p>
    </div>
  );
};

export default HowItWorks;
